import React from 'react'
import Modal from '@groovehq/internal-design-system/lib/components/Modal/Modal'
import SaveSubscriptionButton from 'subapps/settings/components/dataTables/BillingPlanDataTable/SaveSubscriptionButton'
import { styles } from './styles'

const ClaimDiscount = ({ isSaving, percentage, months }) => {
  return (
    <>
      <Modal.Title className="grui text-center px-8">{`🎁 Claim your ${percentage}% off for ${months} months`}</Modal.Title>
      <Modal.Description>
        {`Rest assured, our 30-day Money-Back Guarantee ensures that you are entitled to a full refund if you're not fully satisfied.`}
      </Modal.Description>
      <form id="claim-discount-form">
        <SaveSubscriptionButton
          type="info"
          size="xBig"
          disabled={isSaving}
          css={styles.button}
          className="grui mt-18"
        >
          {isSaving ? 'Saving...' : 'Buy now & save'}
        </SaveSubscriptionButton>
      </form>
    </>
  )
}

export default ClaimDiscount
